// extracted by mini-css-extract-plugin
module.exports = {"articlePageImage":"common-module--article-page-image--D_Bb_"};